<template>
  <div id="app">
    <Header></Header>
    <router-view :key="$route.fullPath"></router-view>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    async testSubmit() {
      try {
        const response = await fetch("http://127.0.0.1:8087/api/feedback", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: "测试用户",
            email: "test@qq.com",
            phone: "13800138000",
            content: "前后端联调成功！"
          }),
        });

        const data = await response.json();
        alert("✅ 提交成功！项目完成！");
        console.log("返回结果：", data);
      } catch (error) {
        alert("请求失败：" + error.message);
        console.error(error);
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue